import Vue from 'vue'
import App from './App.vue'
import router from './routing/router'
import store from './vuex/store'
import './helpers/registerServiceWorker'

Vue.config.productionTip = false

// Main Sass file
import './assets/sass/main.scss'

// Font awesome icons
import 'font-awesome/css/font-awesome.min.css'

// Import Axios for all network requests
import axios, { AxiosResponse } from "axios";

// Fetch the token
let token = localStorage.getItem("api_token");

// If the token exist, set it in the authorization
if (token) {
    // Axios configuration
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    axios.defaults.headers.common["Authorization"] = "Bearer ".concat(token);
}

// Define the base api url
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

Raven
    .config('https://3a62517d90554517a177c451e3f6d365@sentry.io/306895')
    .addPlugin(RavenVue, Vue)
    .install();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.ts